import { loginExchange } from 'api';

export interface OAuthRequest {
  grant_type: 'authorization_code';
  code: string;
  redirect_uri: string | undefined;
  client_id: string | undefined;
}

export interface OAuthResponse {
  access_token: string;
  token_type: string;
  expires_in: number;
  refresh_token: string;
  first_login: boolean;
}

export const postExchange = (data: OAuthRequest): Promise<OAuthResponse> =>
  loginExchange
    .post<OAuthResponse>('', {
      ...data,
    })
    .then((response) => response.data);
